import * as React from "react";
const SvgIcWatch = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M16 1V5H19V19H16V23H8V19H5V5H8V1H16ZM16 16H8V8H16V16Z" fill="currentColor" /></svg>;
export default SvgIcWatch;